import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Search from '../../../component/common/Search';
import ChatMessagesContainer from '../ChatMessagesContainer';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  changeActiveChat,
  chatProjectLoadChatsSuccess,
  fetchNewProjectChat,
  fetchProjectChats,
  fetchReplaceOrAddProjectChat,
} from '../actions';
import ChatListItem from '../../../component/chat/ChatListItem';
import InfiniteScroll from '../../../component/common/InfiniteScroll';
import ChatLoadingSpinner from '../../../component/chat/ChatLoadingSpinner';

export class ChatProjectContainer extends Component {
  static propTypes = {
    history: PropTypes.shape({
      location: PropTypes.object.isRequired,
      push: PropTypes.func.isRequired,
    }),
  };

  state = {
    chatActiveId: null,
    limit: 20,
    chatActiveProduct: null,
    search: '',
  };

  chatListContainerRef = React.createRef();
  chatListRef = React.createRef();

  wsCompanyChannelOnChatCreated = (res) => {
    if (this.props.activeProjectId === res.data.projectId) {
      this.props.fetchNewChat(this.props.activeCompanyId, res.data.chatId);
    }
  };

  wsCompanyChannelOnNewChatMessage = (res) => {
    if (this.props.activeProjectId === res.data.projectId) {
      this.props.fetchReplaceOrAddChat(this.props.activeCompanyId, res.data.chatId);
    }
  };

  onFetchProjectChats = (page) => {
    this.props.fetchProjectChats(
      this.props.activeCompanyId,
      this.props.activeProjectId,
      {
        page,
        limit: this.state.limit,
        search: this.state.search,
      },
      page === 1
    );
  };

  onSearchChange = (search) => {
    this.setState({ search });
  };

  componentDidMount() {
    if (this.props.wsCompanyChannel) {
      this.props.wsCompanyChannel.bind('chatCreated', this.wsCompanyChannelOnChatCreated);
      this.props.wsCompanyChannel.bind('newChatMessage', this.wsCompanyChannelOnNewChatMessage);
    }

    if (this.props.chats.length > 0) {
      this.props.selectChat(this.props.chats[0]);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.wsCompanyChannel && this.props.wsCompanyChannel) ||
      (prevProps.wsCompanyChannel &&
        this.props.wsCompanyChannel &&
        this.props.wsCompanyChannel.name !== prevProps.wsCompanyChannel.name)
    ) {
      this.props.wsCompanyChannel.bind('chatCreated', this.wsCompanyChannelOnChatCreated);
      this.props.wsCompanyChannel.bind('newChatMessage', this.wsCompanyChannelOnNewChatMessage);
    }

    if (
      (prevProps.chats.length === 0 && this.props.chats.length > 0) ||
      // When search/filter totalChats is changed before loading flag is set to false
      (prevProps.totalChats !== this.props.totalChats && this.props.chatsLoading)
    ) {
      this.props.selectChat(this.props.chats[0]);
    }
  }

  componentWillUnmount() {
    if (this.props.wsCompanyChannel) {
      this.props.wsCompanyChannel.unbind('chatCreated', this.wsCompanyChannelOnChatCreated);
      this.props.wsCompanyChannel.unbind('newChatMessage', this.wsCompanyChannelOnNewChatMessage);
    }
    this.props.selectChat(null);
    this.props.cleanProjectChats();
  }

  render() {
    const { activeChat } = this.props;
    const activeChatId = activeChat ? activeChat._id : null;
    const activeProject = this.props.projects.filter(
      (proj) => proj._id === this.props.activeProjectId
    )[0];
    const activeProjectName = activeProject ? activeProject.name : '';
    const chatList = this.props.chats.map((chat) => (
      <ChatListItem
        key={chat._id}
        activeCompanyId={this.props.activeCompanyId}
        chatActiveId={activeChatId}
        chat={chat}
        onClick={() => {
          if (chat._id !== activeChatId) {
            this.props.selectChat(chat);
          }
        }}
      />
    ));

    if (this.props.chatsLoading) {
      chatList.push(<ChatLoadingSpinner key={'loading-spinner'} />);
    }

    return (
      <div className="messages-container">
        <InfiniteScroll
          containerRef={this.chatListContainerRef}
          contentRef={this.chatListRef}
          load={this.onFetchProjectChats}
          loading={this.props.chatsLoading}
          itemsCount={this.props.chats.length}
          totalCount={this.props.totalChats}
          listActiveId={this.props.activeProjectId}
          search={this.state.search}
        >
          <div ref={this.chatListContainerRef} className="messages-chat-rooms">
            <div className="messages-heading">
              <h3>{activeProjectName}</h3>
              <Search search={this.state.search} setSearch={this.onSearchChange} />
            </div>
            <div ref={this.chatListRef} className="chat-previews">
              {chatList}
            </div>
          </div>
        </InfiniteScroll>
        {this.props.activeChat && (
          <ChatMessagesContainer history={this.props.history} chat={this.props.activeChat} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeCompanyId: state.dashboard.activeCompanyId,
  activeCompany: state.dashboard.company,
  activeProjectId: state.dashboard.activeProjectId,
  projects: state.dashboard.projects,
  wsCompanyChannel: state.dashboard.ws.companyChannel,
  chats: state.dashboard.chats.project.data.items,
  totalChats: state.dashboard.chats.project.data.totalCount,
  chatsLoading: state.dashboard.chats.project.loading,
  activeChat: state.dashboard.chats.activeChat,
});

const mapDispatchToProps = (dispatch) => ({
  fetchProjectChats: (companyId, projectId, params, isFirstPage) =>
    dispatch(fetchProjectChats(companyId, projectId, params, isFirstPage)),
  fetchNewChat: (companyId, chatId) => {
    dispatch(fetchNewProjectChat(companyId, chatId));
  },
  fetchReplaceOrAddChat: (companyId, chatId) => {
    dispatch(fetchReplaceOrAddProjectChat(companyId, chatId));
  },
  selectChat: (chat) => {
    dispatch(changeActiveChat(chat));
  },
  cleanProjectChats: () => {
    dispatch(chatProjectLoadChatsSuccess({ items: [], totalCount: 0 }, true));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChatProjectContainer)
);



// WEBPACK FOOTER //
// ./src/container/chat/ChatProjectContainer/index.js